import type { CaseStudy } from "@/utils/caseStudiesCatalog";
import type { LibraryItem } from "@/lib/mock/library";
import { contentTag } from "@/lib/content-tag";

const BLOG_ACCENT = "#f59e0b";

/**
 * Map a published case study (the "Blogs" content) into a Library card item so
 * the Library Blogs section shows the REAL articles with their thumbnails.
 * The card id is the slug so selecting it routes to /blog/{slug}.
 */
export function caseStudyToLibraryItem(s: CaseStudy): LibraryItem {
  const author = s.author?.name ? s.author.name : "Xynth";
  return {
    id: s.slug,
    kind: "idea",
    title: s.headline,
    blurb: s.subtitle || "",
    meta: `${author} · ${s.readTime}`,
    accent: BLOG_ACCENT,
    topic: "",
    thumbnailUrl: s.thumbnailUrl || null,
    uses: s.views || 0,
    tags: [contentTag(`${s.headline} ${(s.tags || []).join(" ")}`)],
  };
}
